// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumb {
  font-size: 13px;
}
.breadcrumb a {
  text-decoration: none;
}
.breadcrumb .mat-icon {
  font-size: 20px;
  height: 20px;
  width: 20px;
  padding: 0 6px;
}
.breadcrumb .breadcrumb-title.active {
  text-transform: uppercase;
  font-weight: 500;
}
.breadcrumb .breadcrumb-item + .breadcrumb-item:before {
  display: inline-block;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  content: "/";
}`, "",{"version":3,"sources":["webpack://./src/app/shared/breadcrumb/breadcrumb.component.scss","webpack://./../../LMS_v20_Before%20Security%20Audit%20Fixes/Edulink/src/app/shared/breadcrumb/breadcrumb.component.scss"],"names":[],"mappings":"AAGA;EACI,eAAA;ACFJ;ADGI;EACI,qBAAA;ACDR;ADGI;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;ACDR;ADGI;EACI,yBAAA;EACA,gBAAA;ACDR;ADGI;EACI,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,YAAA;ACDR","sourcesContent":["// ==========================================================================\r\n// Component: Breadcrumb.component\r\n// ==========================================================================\r\n.breadcrumb{\r\n    font-size: 13px;\r\n    a{\r\n        text-decoration: none;\r\n    }\r\n    .mat-icon{\r\n        font-size: 20px;\r\n        height: 20px;\r\n        width: 20px;\r\n        padding: 0 6px;\r\n    }\r\n    .breadcrumb-title.active{\r\n        text-transform: uppercase;\r\n        font-weight: 500;\r\n    }\r\n    .breadcrumb-item+.breadcrumb-item:before{\r\n        display: inline-block;\r\n        padding-right: .5rem;\r\n        padding-left: .5rem;\r\n        content: \"/\";\r\n    }\r\n}",".breadcrumb {\n  font-size: 13px;\n}\n.breadcrumb a {\n  text-decoration: none;\n}\n.breadcrumb .mat-icon {\n  font-size: 20px;\n  height: 20px;\n  width: 20px;\n  padding: 0 6px;\n}\n.breadcrumb .breadcrumb-title.active {\n  text-transform: uppercase;\n  font-weight: 500;\n}\n.breadcrumb .breadcrumb-item + .breadcrumb-item:before {\n  display: inline-block;\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n  content: \"/\";\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
